import { Box, Typography, Grid, IconButton, Button, Tooltip } from "@material-ui/core";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import LoadingData from "components/Loading/LoadingData";
import {
  columnTextField,
  sortableField,
} from "utils/tables-utils";
import themeColorsDesingSystem from "assets/theme/ds-colors";
import RefreshIcon from "@mui/icons-material/Refresh";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { utils, writeFileXLSX } from "xlsx";

const STATUS_LABEL = {
  AguardandoEstoque: "Aguardando Estoque",
  Notificado: "Notificado",
  Vendido: "Vendido",
  Expirado: "Expirado",
};

const STATUS_STYLE = {
  AGUARDANDO_ESTOQUE: {
    bg: themeColorsDesingSystem.yellow?.background || "#fff8e1",
    color: themeColorsDesingSystem.yellow?.main || "#f57c00",
  },
  NOTIFICADO: {
    bg: themeColorsDesingSystem.blue?.background || "#e3f2fd",
    color: themeColorsDesingSystem.blue?.main || "#1976d2",
  },
  VENDIDO: {
    bg: themeColorsDesingSystem.green?.backgroundActive || "#e8f5e9",
    color: themeColorsDesingSystem.green?.main || "#2e7d32",
  },
  EXPIRADO: {
    bg: "#f5f5f5",
    color: themeColorsDesingSystem.gray?.main || "#616161",
  },
  AguardandoEstoque: { bg: themeColorsDesingSystem.yellow?.background || "#fff8e1", color: themeColorsDesingSystem.yellow?.main || "#f57c00" },
  Notificado: { bg: themeColorsDesingSystem.blue?.background || "#e3f2fd", color: themeColorsDesingSystem.blue?.main || "#1976d2" },
  Vendido: { bg: themeColorsDesingSystem.green?.backgroundActive || "#e8f5e9", color: themeColorsDesingSystem.green?.main || "#2e7d32" },
  Expirado: { bg: "#f5f5f5", color: themeColorsDesingSystem.gray?.main || "#616161" },
};

export default function TableProdutosDesejo({
  data,
  loading,
  onViewDetails,
  onResearch,
  totalRegistros,
}) {
  const columnModel = [
    sortableField({
      dataField: "idProdutoDesejoDigital",
      text: "ID do Produto Desejo",
      align: "center",
    }),
    sortableField({
      dataField: "dataCriacao",
      text: "Data de criação",
      align: "center",
      formatter: (cell) => {
        if (!cell) return "-";
        if (typeof cell === "string" && cell.length >= 10) {
          return `${cell.substring(8, 10)}/${cell.substring(5, 7)}/${cell.substring(0, 4)}`;
        }
        const date = new Date(cell);
        return Number.isNaN(date.getTime()) ? "-" : cell;
      },
      csvFormatter: (cell) => {
        if (!cell) return "";
        if (typeof cell === "string" && cell.length >= 10) {
          return `${cell.substring(8, 10)}/${cell.substring(5, 7)}/${cell.substring(0, 4)}`;
        }
        return cell;
      },
    }),
    sortableField({
      dataField: "descricaoProduto",
      text: "Produto",
      align: "center",
    }),
    sortableField({
      dataField: "nomeLoja",
      text: "Loja",
      align: "center",
    }),
    columnTextField({
      dataField: "nomeCliente",
      text: "Cliente",
      align: "center",
    }),
    columnTextField({
      dataField: "nomeVendedor",
      text: "Vendedor responsável",
      align: "center",
    }),
    columnTextField({
      dataField: "status",
      text: "Status atual",
      align: "center",
      formatter: (_, row) => {
        const s = STATUS_STYLE[row.status] || STATUS_STYLE.AguardandoEstoque || STATUS_STYLE.AGUARDANDO_ESTOQUE;
        return (
          <Box
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "0.25rem",
              padding: "0.25rem 0.5rem",
              borderRadius: "0.25rem",
              backgroundColor: s.bg,
              color: s.color,
            }}
          >
            {STATUS_LABEL[row.status] || row.status}
          </Box>
        );
      },
      csvFormatter: (cell) => STATUS_LABEL[cell] || cell || "",
    }),
    columnTextField({
      dataField: "Acoes",
      text: "Ações",
      align: "center",
      formatter: (_, row) => (
        <Tooltip title="Visualizar detalhes do Produto Desejo">
          <IconButton
            size="small"
            onClick={() => onViewDetails?.(row)}
            aria-label="Visualizar detalhes"
          >
            <VisibilityIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    }),
  ];

  const handleExportExcel = () => {
    const sheetData = data.map((row) => ({
      "ID do Produto Desejo": row.idProdutoDesejoDigital,
      "Data de criação": row.dataCriacaoFormat || row.dataCriacao,
      Produto: row.descricaoProduto,
      Loja: row.nomeLoja,
      Cliente: row.nomeCliente,
      "E-mail cliente": row.emailCliente,
      "Vendedor responsável": row.nomeVendedor,
      "Status atual": STATUS_LABEL[row.status] || row.status,
      Observações: row.observacoes,
    }));
    const ws = utils.json_to_sheet(sheetData);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Produtos Desejo");
    writeFileXLSX(wb, "ProdutosDesejo.xlsx");
  };

  return (
    <div>
      {loading ? (
        <LoadingData searching={true} label="Buscando produtos desejo..." />
      ) : (
        data.length > 0 ? (
          <ToolkitTable
            keyField="idProdutoDesejoDigital"
            dataTable={data}
            columnModel={columnModel}
            notFoundTitle="Sua pesquisa não encontrou nenhum resultado correspondente."
            searched={true}
            CustomHeader={() => (
              <Grid
                container
                justify="space-between"
                spacing={2}
                style={{ padding: "0 20px 20px 20px" }}
              >
                <Grid item>
                  <Grid container spacing={2} alignItems="center">
                    <Typography component="span">Produtos Desejo</Typography>
                    {totalRegistros != null && (
                      <Typography
                        component="span"
                        variant="body2"
                        color="textSecondary"
                        style={{ marginLeft: 8 }}
                      >
                        ({totalRegistros} {totalRegistros === 1 ? "registro" : "registros"})
                      </Typography>
                    )}
                    {onResearch && (
                      <Tooltip title="Atualizar">
                        <IconButton
                          size="small"
                          onClick={onResearch}
                          aria-label="Atualizar"
                        >
                          <RefreshIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Grid>
                </Grid>
                <Grid item>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleExportExcel}
                    disabled={loading}
                  >
                    Exportar para Excel
                  </Button>
                </Grid>
              </Grid>
            )}
            pagination={{
              options: [10, 25, 50, 100],
              defaultOption: 25,
              showTotal: true,
            }}
          />
        ) : (
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 20,
            }}
          >
            <Typography color="textSecondary">
              Nenhum produto desejo encontrado.
            </Typography>
          </Box>
        )
      )}
    </div>
  );
}
